import CustomTablePagination from './CustomTablePagination';

export default CustomTablePagination;
